<footer id="footer" class="primary-background">
  <div class="main-text">DUNA - Digital Uddannelsesadministration</div>
  <div
    class="version-display"
    (click)="onVersionClick()"
    [class.update-available]="showUpdateIndicator$ | async"
    title="Click to check for updates"
  >
    V. {{ versionDisplay$ | async }}
    @if (showUpdateIndicator$ | async) {
    <span class="update-indicator">●</span>
    }
  </div>
</footer>
